import * as React from "react";
import { useEffect, useState } from "react";
import {
  Typography,
  Grid,
  Box,
  Button,
  Popper,
  Stack,
  Grow,
  ClickAwayListener,
  Paper,
  Modal,
  Menu,
  MenuItem,
  MenuList,
  styled,
  LinearProgress,
  linearProgressClasses
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ChecklistIcon } from "../../../../assets/images/checklist_icon.svg";
import { ReactComponent as DocumentIcon } from "../../../../assets/images/document-icon.svg";
import { ReactComponent as InterviewIcon } from "../../../../assets/images/interviewPrepIcon.svg";
import { ReactComponent as EditAssessment } from "../../../../assets/images/edit-new-icon.svg";
import { ReactComponent as Refresh } from "../../../../assets/images/refresh.svg";
import { ReactComponent as SuccessIcon } from "../../../../assets/images/toaster-icons/success-icon.svg";
import AccessService from "../../../../Services/Enterprise/Access.service";
import { toast } from "react-toastify";
import { ReactComponent as DropJobIcon } from "../../../../assets/images/drop-job-icon.svg";
import ConfirmDialog from "../../../../Components/shared/ConfirmDialog";
import Loader from "../../../Loader";
import { success, danger, warning } from "../../../../helpers/message-box";
import axios from "axios";
import moment from "moment";
import { ReactComponent as ActionIcon } from "../../../../assets/images/action-cta-icon.svg";
import { formatDate } from "../../../../helpers/helper-data";
import { ReactComponent as Sparkle } from "../../../../assets/images/sparkle.svg";
import { ReactComponent as ResumeMissingDetailsImage } from "../../../../assets/images/resumeMissingDetailsImage.svg";
import { color } from "d3";
import { ReactComponent as OutreachIcon } from "../../../../assets/images/outreach-icon.svg";
import ApiCalls from "../../../../api/customAxios";


export default function JobMenu(props) {
  //alert(JSON.stringify(props));
  const navigate = useNavigate();

  const candidateId = localStorage.getItem("candidateId");
  const userType = localStorage.getItem("userType");
  const [openFailedJobBoardsPrompt, setOpenFailedJobBoardsPrompt] =
    React.useState(false);
  const [jobBoardsPostingFailedMsg, setJobBoardsPostingFailedMsg] =
    React.useState([]);
  const [prefillProgressValue, setPrefillProgressValue] = React.useState(0);

  const goToAssessment = (id, e, checkListId) => {
    e.preventDefault();
    e.stopPropagation();
    if (checkIfUserCanEditJob()) {
      navigate("/enterprise/screeningQuestions", {
        state: { id: id, checkListId: checkListId },
      });
    }
  };

  const goToSkillChecklist = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/enterprise/add-checklist", { state: { job: props.job } });
  };

  const goToMessages = (jobId, createdBy, e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate("/enterprise/message-list/" + jobId + "/" + createdBy);
  };

  const checkIfUserCanEditJob = () => {
    setOpen(false);
    if (userType === "S" || userType === "C") {
      if (candidateId !== props.job.createdBy) {
        setOpen(false);
        danger("You do not have rights to edit this job.");
        return false;
      }
    }
    return true;
  };

  const editCreateProject = (id, e, checkListId, refreshJob) => {
    e.preventDefault();
    e.stopPropagation();
    if (checkIfUserCanEditJob()) {
      navigate("/enterprise/postJob", {
        state: { id: id, checkListId: checkListId, refreshJob: refreshJob },
      });
    }
  };

  const [open, setOpen] = React.useState(false);
  const [open1, setOpen1] = React.useState(false);
  const [confirmPostToJobBoard, setConfirmPostToJobBoard] = React.useState(false);
  const [refreshedJob, setRefreshedJob] = useState(null);
  const [isLoading, setIsLoading] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [openInterviewPrep, setOpenInterviewPrep] = React.useState(false);
  const [question, setQuestion] = React.useState([]);
  const [index, setIndex] = React.useState(0);
  const [activeQuestion, setActiveQuestion] = React.useState(null);
  const [pageno, setPageNo] = React.useState(0);
  const [isLoadingModal, setIsLoadingModal] = React.useState(false);
  const [isApiCallSucessful, setIsApiCallSucessful] = React.useState(false);
  const [interviewModalHandler, setInterviewModalHandler] = React.useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = React.useState(false);

  const handleOpenInterviewPrep = async (page) => {
    setInterviewModalHandler(true);
    if (question.length) {
      setOpenInterviewPrep(true);
      return;
    }
    setIsLoadingModal(true);
    await getQuestions(pageno);
  };
  const getNextQuestion = () => {
    if (index < question.length) {
      const newIndex = index + 1;
      if (newIndex === question.length) {
        setIsLoadingModal(true);
        const updatePageno = pageno + 1;
        setPageNo(updatePageno);
        getQuestions(updatePageno);
        return;
      } else {
        setActiveQuestion(question[newIndex]);
      }
      setIndex(newIndex);
      // setQuestion(question);
    }
  };
  const getQuestions = async (pageNo) => {
    setIsApiCallSucessful(true);
    if (!isApiCallSucessful) {
    const divElement = document.createElement("div");
    divElement.innerHTML = props.job.jobDescriptionText.replace(/\n/g, "");
    const textContent = divElement.innerText;
    const payLoad = {
      jobDescription: textContent,
      jobTitle: props.job.jobTitle,
      minYearsOfExperience: props.job.overallExperienceMinimum,
      maxYearsOfExperience: props.job.overallExperienceMaximum || props.job.overallExperienceMinimum,
    };
    const encodedParams = Object.keys(payLoad)
      .map(
        (key) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(payLoad[key])}`
      )
      .join("&");
    let progress = 4;
    const intervalId = setInterval(() => {
      progress = progress < 100 ? progress + 4 : progress;
      setPrefillProgressValue(progress);

      if (progress >= 100) {
        clearInterval(intervalId);
      }
    }, 1150);

    setTimeout(() => {
      setPrefillProgressValue(4);
    }, 0);
      AccessService.getQuestions(pageNo, encodedParams)
      .then(async (res) => {
        if (res) {
          setIsApiCallSucessful(false);
          let data = await JSON.parse(res);
          data = data.map((items) => {
            let question = items.split("Answer:");
            return {
              question:
                question.length > 0
                  ? question[0]
                      .replace(/^\d+\.\s/, "")
                      .replace("//n", "/n")
                      .replace("/n", "")
                      .trim()
                  : "",
              answer:
                question.length > 1
                  ? question[1]
                      .replace("//n", "/n")
                      .replace(/\n/g, "<br>")
                      .trim()
                  : "",
            };
          });
          setQuestion(data);
          setActiveQuestion(data[0]);
          setIndex(0);
          setIsLoadingModal(false);
          setOpenInterviewPrep(true);
          setPrefillProgressValue(0);
        } else {
          setIsApiCallSucessful(false);
          danger("Interview guide generation failed, please try again.");
          setOpenInterviewPrep(false);
          setInterviewModalHandler(false);
          setPrefillProgressValue(0);
          setIsLoadingModal(false);
        }
      })
      .catch(() => {
        setIsApiCallSucessful(false);
        danger("Interview guide generation failed, please try again.");
        setOpenInterviewPrep(false);
        setInterviewModalHandler(false);
        setPrefillProgressValue(0);
        setIsLoadingModal(false);
      });
    } else {
      setInterviewModalHandler(false);
      return;
    }
  };
  const handleCloseInterviewPrep = () => {
    setOpenInterviewPrep(false);
    if (question?.length) {
      setIndex(0);
      setPageNo(0);
      setPrefillProgressValue(0);
      setActiveQuestion(null);
      setInterviewModalHandler(false);
      setQuestion([]);
    }
    // setInterviewModalHandler(false);
  };
  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };
  useEffect(() => {
    document.addEventListener("scroll", () => {
      setOpen(false);
    });
  });

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setOpen(false);
  };

  const dropJob = async (job, event) => {
    setIsLoading(true);
    job["status"] = "D";
    setOpen(false);
    setOpen1(false);
    await AccessService.updateAJob(job)
      .then((res) => {
        props?.setRefreshJobHeader(true);
        success("Your job is dropped / cancelled.");
        // props.jobDropped();
      })
      .catch((e) => {
        if (e) {
          danger(<div>{e.errorMessage}</div>);
        } else {
          danger("Error occured while dropped / cancelled the Job.");
        }
      });
    setIsLoading(false);
  };

  const postToJobBoards = async (jobId) => {
    setIsLoading(true);
    setConfirmPostToJobBoard(false);
    try {
      const res = await AccessService.postToJobBoards(jobId);
      // var boards = res
          //   ?.map(function (item) {
          //     return item.board;
          //   })
          //   .join(", ");
          // if (res[0].message?.includes("Job posting limit is not set")) {
          //   var beanbagmessage = `Job posting limit is not set for job board${
          //     res?.length > 1 ? "s" : ""
          //   } `;
          //   setJobBoardsPostingFailedMsg(
          //     beanbagmessage +
          //       `"${boards}"` +
          //       `. Please update it to enable posting / reposting to the respective job board${res?.length > 1 ? "s" : ""}.`
          //   );
          // } else {
          //   var beanbagmessage = `Job posting limit reached for job board${
          //     res?.length > 1 ? "s" : ""
          //   } `;
          //   setJobBoardsPostingFailedMsg(beanbagmessage + `"${boards}"` + ".");
          // }
      // Function to group error messages
      const groupMessages = (messages) => {
        const grouped = messages.reduce((acc, msg) => {
          const errorMessage = msg.errors?.length
            ? msg.errors.map((err) => err.msg).join("\n")
            : msg.message;
          if (!acc[errorMessage]) {
            acc[errorMessage] = [];
          }
          acc[errorMessage].push(msg.board);
          return acc;
        }, {});
        return Object.entries(grouped).map(([error, boards]) => ({
          error,
          boards
        }));
      };
      const groupedMessages = groupMessages(Array.isArray(res) ? res : [res]);
      // Check beanbagMode before showing success or warning messages
      if (localStorage.getItem("beanbagMode") === "T") {
        warning("Job post unsuccessful: Job board(s) are in test mode.");
      } else if (Array.isArray(res) && groupedMessages.some(({ error }) => error !== "Job posted successfully.")) {
        setJobBoardsPostingFailedMsg(groupedMessages);
        setOpenFailedJobBoardsPrompt(true);
      } else if (Array.isArray(res) || typeof res === "object") {
        success("Posted successfully to job boards.");
      } else {
        // Handle other cases
        if (localStorage.getItem("isBeanbagJobBoardActive") === "N") {
          warning("Job post unsuccessful: Job board(s) are inactive.");
        } else {
          success("Posted successfully to job boards.");
        }
      }
    } catch (e) {
      if (e) {
        danger(<div>{e.errorMessage}</div>);
      } else {
        danger("Error occurred while posting to job boards.");
      }
    } finally {
      setIsLoading(false);
      setOpen(false);
    }
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }
  useEffect(() => {
    const handleClickOutside = (event) => {
        if (refreshedJob && !event.target.closest('.refreshed-job-content')) {
            setRefreshedJob(null);
        }
    };
    document.body.addEventListener('click', handleClickOutside);
    return () => {
        document.body.removeEventListener('click', handleClickOutside);
    };
}, [refreshedJob]);

  const refreshTimeStamp = (id, e) => {
    setIsLoading(true);
    AccessService.updateTimeStamp(id)
      .then((res) => {
        // props.refreshTime(res.lastUpdatedTimestamp, id);
        // console.log("ccc");
        setRefreshedJob(res);
        setIsLoading(false);
        setOpen(false);
        setTimeout(() => {
          setRefreshedJob(null);
        }, 4000);
      })
      .catch((e) => {
        setIsLoading(false);
      });
  };

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }
    prevOpen.current = open;
  }, [open]);
  const handleSendOutReach = async () => {
    setConfirmDialogOpen(false);
    try {
      await ApiCalls.put(`enterprises/initiate/pre-qualification?jobId=${props.job["id"]}`);
      success("Outreach has been sent successfully.");
    } catch (e) {
      danger("Unable to send Outreach.");
    }
  };
  const getMappedErrFieldName = (key) => {
    let field_map = {
      "countryCode": "Location",
      "salaryMin": "Minimum Pay Rate",
      "salaryMax": "Maximum Pay Rate",
    };
    let mappedErrFieldName = (key ? field_map[key] ? field_map[key] : key : "");
    return mappedErrFieldName;
  };
  return (
    <>
      {isLoading && <Loader />}
      {refreshedJob && (
        <Grid className="refresh-job d-flex">
            <Box><SuccessIcon width="20px" height="20px" /></Box>
            <Box className="ml-10">
              Job <b>{refreshedJob?.jobTitle}</b> refreshed, please set the expiry date accordingly. <br />
              <a
                style={{ color: getComputedStyle(document.documentElement).getPropertyValue("--primary-color") }}
                onClick={(event) => {
                  event.preventDefault();
                  event.stopPropagation();
                  editCreateProject(refreshedJob?.id, event, refreshedJob?.checkListId, true);
                }}
              >
                Click here to edit job
              </a>
            </Box>
        </Grid>
      )}
      <Stack direction="row" spacing={2} className="jobdetail-menu">
        <div className="assess-update d-grid">
          <Button
            ref={anchorRef}
            // id="composition-button"
            aria-controls={open ? "composition-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleToggle}
            aria-label="Menu icon"
            disableRipple="true"
            className="p-0"
          >
            <Typography className="d-flex align-center justify-center detail-cta-icon">
              <ActionIcon className="svg-icons"/>
            </Typography>
          </Button>

          <Popper
            style={{ zIndex: "9" }}
            open={open}
            anchorEl={anchorRef.current}
            role={undefined}
            placement="bottom-start"
            transition
            disablePortal
          >
            {({ TransitionProps, placement }) => (
              <Grow
                {...TransitionProps}
                style={{
                  transformOrigin:
                    placement === "bottom-start" ? "left top" : "left bottom",
                }}
              >
                <Paper>
                  <ClickAwayListener
                    onClickAway={handleClose}
                    tabIndex={0}
                    onKeyPress={handleClose}
                  >
                    <MenuList
                      autoFocusItem={open}
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={handleListKeyDown}
                    >
                      <MenuItem
                        onClick={(e) =>
                          editCreateProject(
                            props.job["id"],
                            e,
                            props.job["checkListId"]
                          )
                        }
                        className="p-0"
                        tabIndex={0}
                        onKeypress={(e) =>
                          editCreateProject(
                            props.job["id"],
                            e,
                            props.job["checkListId"]
                          )
                        }
                      >
                        <Typography className="d-flex  f-12 font-weight-400 p-5 pl-10 align-center">
                          <EditAssessment
                            aria-label="Edit icon"
                            className="experience-cont"
                            width="11"
                            height="11"
                          />
                          <span
                            className="gray9"
                            style={{ paddingLeft: "12px" }}
                          >
                            Edit Job
                          </span>
                        </Typography>
                      </MenuItem>
                      <MenuItem
                        onClick={(e) =>
                          goToAssessment(
                            props.job["id"],
                            e,
                            props.job["checkListId"]
                          )
                        }
                        className="p-0"
                        tabIndex={0}
                        onKeyPress={(e) =>
                          goToAssessment(
                            props.job["id"],
                            e,
                            props.job["checkListId"]
                          )
                        }
                      >
                        <Typography className="d-flex  f-12 font-weight-400 p-5 pl-10">
                          <DocumentIcon
                          width="14"
                          height="14"
                            aria-label="Document icon"
                            className="experience-cont"
                          />
                          <span className="pl-10 gray9">
                            Edit Screening Questions
                          </span>
                        </Typography>
                      </MenuItem>
                      {props.value
                        ? props.value == 2 && (
                            <MenuItem
                              onClick={(e) => {
                                handleOpenInterviewPrep(0);
                                setPrefillProgressValue(4);
                              }}
                              onKeyPress={(e) => {
                                handleOpenInterviewPrep(0);
                                setPrefillProgressValue(4);
                              }}
                              className="p-0"
                              tabIndex={0}
                              // onKeyPress={(e) => goToAssessment(props.row["jobId"], e, props.row["checkListId"])}
                            >
                              <Typography className="d-flex f-12 font-weight-400 p-5 pl-10">
                                <InterviewIcon
                                  // style={{ width: "14px" }}
                                  aria-label="interview icon"
                                  className="experience-cont"
                                />
                                <span className="pl-5 gray9">
                                  Interview Guide
                                </span>
                              </Typography>
                            </MenuItem>
                          )
                        : ""}
                      {props.job.status !== "D" ? (
                        <MenuItem
                          onClick={(e) => {
                            if (checkIfUserCanEditJob()) {
                              setOpen1(true);
                            }
                          }}
                          className="p-0 mt-2"
                          tabIndex={0}
                          onKeyPress={(e) => {
                            if (checkIfUserCanEditJob()) {
                              setOpen1(true);
                            }
                          }}
                        >
                          <Typography className="d-flex  f-12 font-weight-400 pl-10 align-center">
                            <DropJobIcon
                              style={{ width: "16px" }}
                              aria-label="DropJob icon"
                              className="experience-cont"
                            />
                            <span
                              style={{ paddingLeft: "8px" }}
                              className="gray9"
                            >
                              Drop / Cancel Job
                            </span>
                          </Typography>
                        </MenuItem>
                      ) : (
                        ""
                      )}
                      <MenuItem
                        onClick={(e) => refreshTimeStamp(props.job.id)}
                        className="p-0 mt-5"
                        tabIndex="0"
                        onKeyPress={(e) => refreshTimeStamp(props.job.id)}
                      >
                        <Typography className="d-flex  f-12 font-weight-400 pl-10">
                          <Refresh
                            style={{ width: "12px", marginLeft: "2px" }}
                            aria-label="Document icon"
                            className="experience-cont"
                          />
                          <span className="pl-10 gray9">Refresh</span>
                        </Typography>
                      </MenuItem>
                      {props.job?.enterprisePublicDto?.isPreqUser == "Y" && <MenuItem
                        onClick={(e) => {
                          setConfirmDialogOpen(true);
                        }}
                        className="p-0 mt-5"
                        tabIndex={0}
                        onKeyPress={(e) => {
                          setConfirmDialogOpen(true);
                        }}
                      >
                        <Typography className="d-flex f-12 font-weight-400 pl-10 align-center">
                          <OutreachIcon
                            width="17px" height="17px"
                            style={{ marginLeft: "2px" }}
                            aria-label="DropJob icon"
                            className="experience-cont mt-4"
                          />
                          <span className="pl-5 gray9">Outreach</span>
                        </Typography>
                      </MenuItem>}
                      {/* Commenting for now */}
                      {((localStorage.getItem("userType") == "Z") ||
                      (localStorage.getItem("userType") == "A") ||
                      (localStorage.getItem("userType") == "T") ||
                      (localStorage.getItem("userType") == "R")) &&
                        localStorage.getItem("isBeanBagUser") === "Y" &&
                        !localStorage.getItem("childEnterpriseId") && (
                          <MenuItem
                            onClick={(e) => setConfirmPostToJobBoard(true)}
                            className="p-0"
                            tabIndex={0}
                            onKeyPress={(e) => setConfirmPostToJobBoard(true)}
                            style={{ marginTop: "6px" }}
                          >
                            {props.job.status == "O" &&
                              formatDate(
                                new Date(
                                  JSON.parse(
                                    JSON.stringify(
                                      props.job?.validTill
                                    ).replace("23:59:59", "00:00:00")
                                  )
                                )
                              ) >=
                                formatDate(moment().format("YYYY-MM-DD")) && (
                                <Typography className="d-flex light-text f-12 font-weight-400 pl-10 align-center">
                                  <DocumentIcon
                                    style={{ width: "14px", marginLeft: "2px" }}
                                    aria-label="Document icon"
                                    className="experience-cont"
                                  />
                                  <span
                                    className="gray9"
                                    style={{ paddingLeft: "9px" }}
                                  >
                                    Post / Repost to Job Boards
                                  </span>
                                </Typography>
                              )}
                          </MenuItem>
                        )}
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </Stack>
      <Modal
        open={openInterviewPrep && interviewModalHandler}
        onClose={handleCloseInterviewPrep}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-content inputcontrasts galaxy-width p-20">
          <Grid xs={12} className="">
            <Grid className="borderRadius-10 side-menu-bg p-10 ml-5 mr-5 mb-30">
              <Grid
                container
                lg={12}
                md={12}
                xs={12}
                className="align-center d-flex"
              >
                <Grid
                  item
                  lg={1}
                  xs={2}
                  className="align-center d-flex justify-center"
                >
                  <Sparkle
                    className="svg-icons-gray1 search-background p-8 borderRadius-50"
                    width="40px"
                    height="40px"
                  />
                </Grid>
                <Grid item lg={11} xs={10}>
                  <Typography className="pl-5 f-16 font-weight-600 primary-shadow-color">
                    This is an auto-generated question to help you prepare for
                    your interview.
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid id="modal-description" className="pt-0">
              <Typography className="sub-text-color f-16 font-weight-500 mb-20 text-justify">
                {activeQuestion?.question}
              </Typography>
              <Typography
                className="f-16 font-weight-500 gray9 text-justify"
                dangerouslySetInnerHTML={{
                  __html: activeQuestion?.answer,
                }}
              />
            </Grid>
          </Grid>

          <Typography className="mb-20 mt-20">
            <div
              style={{
                background: "#D0D5DD",
                height: "1px",
              }}
            />
          </Typography>
          <Grid id="modal-footer" className="justify-end d-flex mr-5">
            <Button
              type="submit"
              className="btn primary-button profileButton cursor-hover"
              onClick={() => {
                getNextQuestion();
                setPrefillProgressValue(4);
              }}
              variant="contained"
              disableRipple="true"
            >
              Get next question
            </Button>
          </Grid>
        </Box>
      </Modal>
      <ConfirmDialog
        open={open1}
        setOpen={setOpen1}
        dialogTitle="Drop / Cancel Job"
        description={"Changing the status of the job will impact associated actions such as scheduled interviews, shortlists, offers, and more. Are you sure you want to proceed?"}
        handleConfirmYes={(e) => dropJob(props.job, e)}
      />
      <Modal
        open={openFailedJobBoardsPrompt}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modalStyle inputcontrasts outline-none fit-content">
          {/* <Typography variant="h5" className="font-weight-500 f-20  gray9">
            {jobBoardsPostingFailedMsg}
          </Typography> */}
          <Typography className="f-24 font-weight-600 heading-text-color align-left">
            Job Posting Status
          </Typography>
          {((jobBoardsPostingFailedMsg?.length > 0) && (jobBoardsPostingFailedMsg[0].status == 400)) ?
          jobBoardsPostingFailedMsg[0].errors?.map((msg, index)=>(
          <Typography className="mt-15 f-14 gray9 d-flex align-start" key={index}>
            <Box className="gray9 font-weight-600">{getMappedErrFieldName(msg?.key)}: </Box>
            <Box className="gray9 font-weight-400 pl-5 align-left">
              {msg?.value}
            </Box>
          </Typography>
          ))
          : jobBoardsPostingFailedMsg?.map((msg, index) => (
            <Typography className="mt-15 f-14 gray9 d-flex align-start" key={index}>
              <Box className="gray9 font-weight-600">
                {msg?.boards.join(', ')}:
              </Box>
              <Box className="gray9 font-weight-400 pl-5 align-left">
                {msg?.error}
              </Box>
            </Typography>
          ))}
          {((jobBoardsPostingFailedMsg?.length > 0) && (jobBoardsPostingFailedMsg[0].status == 400)) ?
          <Typography className="mt-25 f-14 gray9 d-flex align-start">
            <Box className="gray9 font-weight-600">
              Note:
            </Box>
            <Box className="gray9 font-weight-400 pl-5 align-left">
              Edit the job and repost it to the job boards.
            </Box>
          </Typography>
          :
          <Typography className="mt-25 f-14 gray9 d-flex align-start">
            <Box className="gray9 font-weight-600">
              Note:
            </Box>
            <Box className="gray9 font-weight-400 pl-5 align-left">
              Please check the logs on the Beanbag Job Listing page for details.
            </Box>
          </Typography>
          }
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              type="button"
              onClick={() => setOpenFailedJobBoardsPrompt(false)}
              className="btn primary-button w-150"
              variant="contained"
              disableRipple="true"
            >
              OK
            </Button>
          </Typography>
        </Box>
      </Modal>
      <Modal
        open={isLoadingModal}
        onClose={(e) => {
          setIsLoadingModal(false);
          setInterviewModalHandler(false);
          if (!question.length) {
            setOpenInterviewPrep(false);
          e.stopPropagation();
          }
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="modal-content inputcontrasts">
          <Grid
            id="modal-description"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <Grid container spacing={1}>
              <Grid item lg={12} md={12} xs={12}>
                <Box className="m-auto" style={{ width: "175px" }}>
                  <ResumeMissingDetailsImage />
                </Box>
              </Grid>
              <Grid item lg={12} md={12} xs={12}>
                <Typography className="text-center m-auto f-18 font-weight-600 gray9">
                  Please wait until we generate the interview guide
                </Typography>
              </Grid>
              <Grid item lg={12} md={12} xs={12} className="mt-20 mb-10">
                <Box className="m-auto" style={{ width: "300px" }}>
                  <BorderLinearProgress
                    className="resumePrefillProgress"
                    aria-label="Progress bar"
                    variant="determinate"
                    value={prefillProgressValue}
                    borderRadius={10}
                    max={100}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Box>
      </Modal>
      <ConfirmDialog open={confirmDialogOpen}
        setOpen={setConfirmDialogOpen}
        dialogTitle={"Outreach"}
        description={"Are you sure you want to invite the candidates to the pre-qualification process for this job?"}
        handleConfirmYes={handleSendOutReach} />
        <ConfirmDialog
        open={confirmPostToJobBoard}
        setOpen={setConfirmPostToJobBoard}
        dialogTitle="Post / Repost to Job Boards"
        description={"Are you sure?"}
        handleConfirmYes={(e) => postToJobBoards(props.job.id)}
      />
    </>
  );
}

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
  height: "12px !important",
  borderRadius: 10,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor:
      theme.palette.grey[theme.palette.mode === "light" ? 200 : 800],
  },
  [`& .${linearProgressClasses.bar}`]: {
    borderRadius: 10,
    backgroundColor:
      theme.palette.mode === "light"
        ? getComputedStyle(document.documentElement).getPropertyValue(
            "--primary-color"
          )
        : "rgba(68, 91, 199, 0.4)",
  },
}));
